export const BILL_STATUS = { draft: { text: '草稿' }, issued: { text: '已出账' }, voided: { text: '已作废' } }

export const BILL_COLLECTION_STATUS = {
  notIssued: { text: '未出账', status: 'Default' },
  voided: { text: '已作废', status: 'Default' },
  notRequired: { text: '已结清（0 元）', status: 'Default' },
  unpaid: { text: '未结算', status: 'Error' },
  partial: { text: '部分结算', status: 'Processing' },
  paid: { text: '已结清', status: 'Success' },
  refundDue: { text: '待退回', status: 'Warning' }
} as const

export const MONEY_KIND_LABELS = {
  receipt: '收款',
  receiptRefund: '收款退款',
  payment: '付款',
  paymentRefund: '付款退回'
} as const

export const MONEY_STATUS_LABELS = { pending: '待确认', confirmed: '已确认', voided: '已作废' } as const

export const MONEY_KIND_COLORS = {
  receipt: 'green',
  receiptRefund: 'orange',
  payment: 'blue',
  paymentRefund: 'purple'
} as const satisfies Record<keyof typeof MONEY_KIND_LABELS, string>

export const MONEY_STATUS_COLORS = {
  pending: 'gold',
  confirmed: 'green',
  voided: 'red'
} as const satisfies Record<keyof typeof MONEY_STATUS_LABELS, string>

export const BILL_KINDS = {
  rent: '租金',
  water: '水费',
  electricity: '电费',
  service: '服务费',
  deposit: '押金',
  other: '其他',
  propertyManagement: '物业费',
  commission: '佣金',
  outsourcing: '外包',
  salary: '工资',
  reimbursement: '报销',
  repair: '维修',
  office: '办公',
  passThrough: '代收代付'
}

export const DEFAULT_BILL_SEARCH = {
  archived: 'active' as const,
  current: 1,
  pageSize: 20,
  sortField: 'createdAt' as const,
  sortOrder: 'desc' as const
}

export const BILL_STATUS_COLORS = { draft: 'gold', issued: 'green', voided: 'red' } as const satisfies Record<
  keyof typeof BILL_STATUS,
  string
>

export const BILL_KIND_COLORS = {
  rent: 'blue',
  water: 'cyan',
  electricity: 'gold',
  service: 'green',
  deposit: 'purple',
  other: 'default',
  propertyManagement: 'geekblue',
  commission: 'magenta',
  outsourcing: 'volcano',
  salary: 'lime',
  reimbursement: 'orange',
  repair: 'red',
  office: '#597a2b',
  passThrough: '#527a89'
} as const satisfies Record<keyof typeof BILL_KINDS, string>
